// Product Compare
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

import ProductComparePanelWidget from "Fratello/ProductCompare/Widgets/PanelWidget";
import ProductCompareProductWidget from "Fratello/ProductCompare/Widgets/ProductWidget";
import ProductCompareMatrixWidget from "Fratello/ProductCompare/Widgets/MatrixWidget";
import ProductCompareViewsMatrixView from "../ProductCompare/Views/MatrixView";
import ProductCompareHistoryWidget from "Fratello/ProductCompare/Widgets/HistoryWidget";
import ProductCompareLocalStorageWidget from "Fratello/ProductCompare/Widgets/LocalStorageWidget";
import ProductCompareStore from "Fratello/ProductCompare/Stores/CompareStore";
import ProductCompareViewsPanelView from "../ProductCompare/Views/PanelView";
import ProductCompareViewsProductView from "../ProductCompare/Views/ProductView";
import ProductCompareViewsPanelProductView from "../ProductCompare/Views/PanelProductView";

ComponentRegistry.register({
    ProductComparePanelWidget,
    ProductCompareViewsPanelView,
    ProductCompareProductWidget,
    ProductCompareViewsProductView,
    ProductCompareViewsPanelProductView,
    ProductCompareMatrixWidget,
    ProductCompareViewsMatrixView,
    ProductCompareHistoryWidget,
    ProductCompareLocalStorageWidget
});
ComponentRegistry.registerStore({ProductCompareStore});




// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/ProductCompare.jsx